import React, { useEffect, useRef, useState } from 'react';
import { handleError } from '../../Shared/Functions';
import { InstaPayVService } from '../../../services/V3/gozer';
import { CircularProgress } from '@mui/material';

export function InstapayFrame({ tokenType, billingAccountId, complete, errorToast, setOpenPlugin, setCardType }) {
    const iframePlugin = useRef<HTMLIFrameElement>(null)
    const [url, setUrl] = useState<string>("");

    useEffect(() => {
        InstaPayVService.instaPayVGetUrl({
            billingAccountId: billingAccountId,
            tokenType: tokenType
        })
            .then(urlInfo => {
                setUrl(urlInfo);
            }).catch(err => {
                errorToast(handleError(err))
                complete(false)
            });
    }, [])// eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        if (!url) return;
        window.addEventListener("message", eventListener)

        return () => {
            window.removeEventListener("message", eventListener)
        }
    }, [url])// eslint-disable-line react-hooks/exhaustive-deps

    const eventListener = (message) => {
        //if (message.origin !== "https://localhost:3000" || typeof message?.data !== "string") return
        if ((!message.origin.includes(".avr-cloud.com") && !message.origin.includes(".i3verticals.cloud")) || typeof message?.data !== "string") return;

        if (message?.data === "i3payfac_cancel") {
            window.removeEventListener('message', eventListener)
            setOpenPlugin(false)
            complete(false)
        }

        if (message?.data.startsWith("token_id|")) {
            const tokenString = message?.data.split("|");
            
            if (tokenString.length === 3)
                setCardType(tokenString[2])
            window.removeEventListener('message', eventListener)
            complete(tokenString[1])
        }
    }

    const preparePlugin = () => {
        const headScript = document.createElement("script")
        const bodyScript = document.createElement("script")
        headScript.src = url

        headScript.async = false
        iframePlugin.current?.contentWindow?.document.head.appendChild(headScript)

        headScript.onload = () => {
            bodyScript.text = ` 
                        i3Plugins.onPluginCreated = function (type, plugin) {
                        window.parent.postMessage('pluginloaded')
                        if (type == 'payment') {
                            plugin.onEmbed = function (msg) {
                                // Plugin is requesting the id of the element to embed
                                // the plugin in
                                return "divPlugin";
                            }
                            plugin.onCancel = function (msg) {
                                // Handle the user closing the plugin without paying
                                window.parent.postMessage('i3payfac_cancel')
                                this.hide(); // Call the plugin's hide function to hide it
                            }
                            plugin.onTokenize = function (msg) {
                                // Handle the token
                                let cardType = "";

                                if (msg?.fields?.["card_type"]) 
                                    cardType = msg?.fields?.["card_type"];
                                
                                window.parent.postMessage('token_id|' + msg["token_id"] + '|' + cardType)
                                this.hide(); // Call the plugin's hide function to hide it
                            }
                        }
                    }
            `

            bodyScript.async = false
            iframePlugin.current?.contentWindow?.document.body.appendChild(bodyScript)
        }
    }

    let srcDoc = `
        <html>
            <head>
            </head>
            <body>
            </body>
        </html>
    `;

    return (url ?
            <iframe
                style={{ border: "none", width: "100%", height: "100vh" }}
                id="i3payfacframe"
                title="i3payfac"
                srcDoc={srcDoc}
                ref={iframePlugin}
                onLoad={preparePlugin}></iframe> : <div className='loading-container'><CircularProgress color="primary" className='center-spinner' aria-label="Loading" /></div>
    )

}